module.exports = __webpack_public_path__ + "static/media/bee.79a1a3e7.svg";